const projectUtils = {
	/**
	 * Lookup array of spec status options
	 * @type {Array<String>}
	 */
	specStatusOptions: [],

	/**
	 * Lookup array of supplier options
	 * @type {Array<String>}
	 */
	supplierOptions: [],

	/**
	 * Initialize project utilities by loading lists from the database
	 * @param {Object} [model] Optional model to use for database queries
	 * @returns {Promise}
	 */
	projectUtilsInit: function(model) {
		if (projectUtils.pendingInit instanceof Promise) return projectUtils.pendingInit;

		return (projectUtils.pendingInit = Promise.resolve()
			.then(() => {
				// Load both spec status and suppliers lists
				const promises = [];

				if (model) {
					// Server-side: query the database directly
					promises.push(model.findOne({ value: 'specStatusOptions', status: 'active', enabled: true }));
					promises.push(model.findOne({ value: 'suppliers', status: 'active', enabled: true }));
				} else {
					// Client-side: use Vue's HTTP service (catch individually so one failure doesn't block the other)
					var $http = Vue.services().$http;
					promises.push($http.get('/api/lists/by-value/specStatusOptions').then((res) => res.data).catch(() => null));
					promises.push($http.get('/api/lists/by-value/suppliers').then((res) => res.data).catch(() => null));
				}

				return Promise.all(promises);
			})
			.then(([specStatusList, suppliersList]) => {
				// Update spec status options
				if (specStatusList) {
					const newSpecStatusOptions = specStatusList.items
						.filter((item) => item.value && (item.enabled ?? true))
						.map((item) => item.value);

					// Replace contents in-place
					projectUtils.specStatusOptions.splice(0, projectUtils.specStatusOptions.length, ...newSpecStatusOptions);
				}

				// Update supplier options
				if (suppliersList) {
					const newSupplierOptions = suppliersList.items
						.filter((item) => item.value && (item.enabled ?? true))
						.map((item) => item.value)
						.sort(); // Sort alphabetically A-Z

					// Replace contents in-place
					projectUtils.supplierOptions.splice(0, projectUtils.supplierOptions.length, ...newSupplierOptions);
				}
			})
			.catch(e => {
				projectUtils.pendingInit = null; // Allow retry on next call
				throw e;
			}));
	},
};

module.exports = projectUtils;
